// import { createBrowserHistory, History } from 'history';
import createBrowserHistory from "history/createBrowserHistory";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Provider as InversifyProvider } from "inversify-react";
// import { ChangeNotification } from 'react-inversify';
import { Provider } from "react-redux";
import { ConnectedRouter } from "react-router-redux";
import App from "./components/App";
import Home from "./components/home/home";
import { container } from "./inversify.config";
import registerServiceWorker, {unregister} from "./registerServiceWorker";
import storeInit from "./stores/main.store";
import { BrowserRouter as Router } from "react-router-dom";
import "./assets/scss/app.scss";

const history = createBrowserHistory({ basename: "/" });
const store = storeInit(history);

(window as any).store = store;

ReactDOM.hydrate(
    <Provider store={store}>
        <InversifyProvider container={container}>
            <ConnectedRouter store={store} history={history}>
                <Router>
                    <App />
                </Router>
            </ConnectedRouter>
        </InversifyProvider>
    </Provider>,
    document.getElementById("root") as HTMLElement,
);
unregister();
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx